import { connect } from 'react-redux';
import { changePassword } from '../../redux/modules/auth';
import ChangePassword from './change-password';

export default connect(
  ({ auth: { user } }) => ({ user }),
  { changePassword }
)(ChangePassword);
